import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const TemplatesList = Loadable(lazy(() => import('./TemplatesList')));
const TemplatesForm = Loadable(lazy(() => import('./TemplatesForm')));
const TemplatesDetails = Loadable(lazy(() => import('./TemplatesDetails')));

const templatesRoutes = [
  { path: '/templates', element: <TemplatesList />, auth: authRoles.admin },
  { path: '/templates/:id', element: <TemplatesDetails />, auth: authRoles.admin },
  { path: '/templates/update/:id', element: <TemplatesForm />, auth: authRoles.admin },
];

export default templatesRoutes;